import { Component } from '@angular/core';

@Component({
  selector: 'app-motion-background',
  standalone: true,
  template: `
    <div class="particles"></div>
  `,
  styles: [`
    .particles {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: 
        radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px),
        radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px);
      background-size: 50px 50px;
      background-position: 0 0, 25px 25px;
      animation: particleMove 20s linear infinite;
      pointer-events: none;
    }

    @keyframes particleMove {
      0% { background-position: 0 0, 25px 25px; }
      100% { background-position: 100px 100px, 125px 125px; }
    }
  `]
})
export class MotionBackgroundComponent {}